import { CompactText } from 'ui/CompactText';
import { useEffect, useState } from 'react';

import {
  canPlayNotifySound,
  denyNotifyConsent,
  getBrowserNotifyPermission,
  getStoredNotifyConsent,
  grantNotifyConsent,
  subscribeNotifyConsent,
} from 'utils/desktopNotify';

import styles from './DesktopNotifySettings.module.scss';

export function DesktopNotifySettings({ showTitle = true }: { showTitle?: boolean }) {
  const [consent, setConsent] = useState(getStoredNotifyConsent);
  const [browserPermission, setBrowserPermission] = useState(getBrowserNotifyPermission);

  useEffect(() => {
    const sync = () => {
      setConsent(getStoredNotifyConsent());
      setBrowserPermission(getBrowserNotifyPermission());
    };
    sync();
    return subscribeNotifyConsent(sync);
  }, []);

  const enabled = consent === 'granted';

  const toggle = () => {
    if (enabled) {
      denyNotifyConsent();
      return;
    }
    void grantNotifyConsent().then(() => {
      setBrowserPermission(getBrowserNotifyPermission());
    });
  };

  const browserHint =
    browserPermission === 'granted'
      ? 'Браузер: уведомления разрешены'
      : browserPermission === 'denied'
        ? 'Браузер запретил всплывающие уведомления - останется только звук, если согласие уже дано'
        : browserPermission === 'unsupported'
          ? 'Этот браузер не поддерживает системные уведомления - будет только звук'
          : 'Браузер еще не спрашивал разрешение';

  return (
    <div className={styles.block}>
      {showTitle ? <h2>Уведомления</h2> : null}
      <label className={styles.row}>
        <input type='checkbox' checked={enabled} onChange={toggle} />
        <span className={styles.box} aria-hidden />
        <span>Звук и уведомления о сообщениях</span>
      </label>
      <CompactText className={styles.hint} tone={'info'}>
        {enabled && canPlayNotifySound()
          ? `Включено. ${browserHint}.`
          : `Выключено. ${browserHint}.`}
      </CompactText>
    </div>
  );
}
